import {useDispatch, useSelector} from "react-redux";
import React, { useState} from "react";
import {TABLES} from "../../../../../Apis/Tables";
import DropDownMenuProfile from "../../../../../components/DropDown/DropDownMenuProfile";
import {permissionObj} from "../../../../../Helpers/permission";
import DropDownMenuItem from "../../../../../components/DropDown/DropDownMenuItem";
import routes from "../../../../../Routes/routes";
import {CancelIconsOptions, NextIconsOptions} from "../../../../../components/buttons/IconButtons";
import CustomChip from "../../../../../components/CustomChip";
import {statusBorderColor, statusColor, statusFontColor} from "../../../../../enums/statusColorEnum";
import {status, STATUS_MODEL} from "../../../../../enums/statusEnum";
import TableFunction from "../../../../../components/table/TableFunction";
import {
    CRITERIA_MODEL, DEFAULT_LEFT, LEFT_SECOND_COLUMN_WITHOUT_CHECKBOX,
    SEARCH_MODEL,
    WIDTH_COLUMN_FIXED, WIDTH_TOOLTIP_FIXED_COLUMN
} from "../../../../../components/table/Model/TableModel";
import {SearchByFilters, SimpleSearch} from "../../../../../reduxToolkit/Search/SearchApi";
import {colors} from "../../../../../enums/colors";
import {CancelInvitation} from "../../../../../reduxToolkit/Invitation/InvitationApi";
import {toast} from "react-toastify";
import {getIdentityValidationTypeById} from "../../Visitor/Model/Model";
import {EMPTY_VALUES, getFullName} from "../../../../../Apis/functions";
import CustomTooltip from "../../../../../components/CustomTooltip";
import {INVITATION_VIEW_TYPE, invitationInTime, VISITOR_SUB_VIEW_MODEL} from "../../Invitation/Model/Model";
import {TABS_VISITOR} from "../../Model/Model";
import {DATA_TYPE_MODEL, ORDER_MODEL, SEARCH_OPERATION_MODEL} from "../../../../Modals/Model/Model";
import {fieldModelName} from "../../../../../enums/fieldModelEnum";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */

/**
 * Custom hook or controller for managing a searchable, paginated list with selectable rows,
 * cancellation actions, and options rendering.
 *
 * @param {Array} selectedList - List of selected row elements (e.g., checkboxes).
 * @param {Function} setSelectedList - Setter function to update selectedList.
 * @param {Object} criteria - Search or filter criteria applied to the data.
 * @param {Function} setCriteria - Setter function to update search criteria.
 * @param {Function} searchElement - Callback or logic to perform a search.
 * @param {Array} finalArray - Final processed data array used in the view.
 * @param {Function} setSearch - Setter to update the search string or object.
 * @param setBodyForExport - Sets the data body for export functionality (required)
 * @param {boolean} modified - Flag indicating that data has changed and the table should refresh (required).
 * @param {Function} setModified - Setter used to update the `modified` flag and trigger data reloads (required).
 * @constructor
 */

export const InvitationStatusApp = ({
                                        selectedList,
                                        setSelectedList,
                                        setCriteria,
                                        searchElement,
                                        finalArray,
                                        setBodyForExport,
                                        modified,
                                        setModified
}) => {
    const dispatch = useDispatch();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const {user} = useSelector((state) => state.authenticatioauthennSlice);
    const {permission} = useSelector((state) => state.authenticatioauthennSlice);
    const [expandedRowId, setExpandedRowId] = useState(null);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [results, setResults] = useState(null); // Store the search results
    const option = TABLES.VISITOR_REQUEST;
    const searchId = 'txt_isa_search_requested_invitation';
    const [simpleSearch, setSimpleSearch] = useState(false); // Simple search flag
    const [showCancel, setShowCancel] = useState(false);

    const RenderOptionsMenu = (row) => {
        const isOverdue = !invitationInTime(row.endDate);
        return (
            <>
                <DropDownMenuProfile openMenu={openMenu} handleMenuToggle={handleMenuToggle}
                                     menuId={`menu-${row.id}`} isAccordion={true}>

                    {(DEV || permission?.includes(permissionObj?.WEB_APPROVAL_FLOW_READ))
                    && row?.approvalFlowId
                    && (
                        <DropDownMenuItem
                            id={"btn_isa_approval-tracker" + row.id}
                            index={row.id}
                            handleClose={handleClose}
                            name={t('approval_manager')}
                            url={{
                                pathname: `${routes.approvalTracker.details}${TABLES.USER_INVITATION}/${row?.id}/${row?.approvalFlowId}`,
                                state: {
                                    backUrl:{
                                        pathname: routes.visitor.list,
                                        state: { currentTab: TABS_VISITOR.REQUESTS.INDEX
                                        }
                                    }
                                }
                            }}
                            icon={<NextIconsOptions />}
                        />
                    )}
                    {(DEV || permission?.includes(permissionObj?.WEB_VISITOR_INVITATION_STATUS_DOCUMENTATION_READ)) && (
                        <DropDownMenuItem
                            id={"btn_isa_documentation" + row.id}
                            index={row.id}
                            handleClose={handleClose}
                            name={t('documentary_manage')}
                            url={{
                                pathname: routes.visitorRequest.documentation, //Go url
                                state: {
                                    id: row.id,
                                    backUrl:{
                                        pathname: routes.visitor.list, //Back url
                                        state: {
                                            currentTab: TABS_VISITOR.REQUESTS.INDEX,
                                            currentSubView: VISITOR_SUB_VIEW_MODEL.REQUESTS.INVITATION_STATUS,
                                            invitationId:row.id,
                                            isOverdue: isOverdue
                                    }
                                }
                            }}}
                            icon={<NextIconsOptions/>}
                        />
                    )}
                    {(DEV || permission?.includes(permissionObj?.WEB_VISITOR_INVITATION_STATUS_IDENTIFY_READ)) && (
                        <DropDownMenuItem
                            id={"btn_isa_identity" + row.id}
                            index={row.id}
                            handleClose={handleClose}
                            name={t('identify_manage')}
                            url={{pathname: routes.visitorRequest.identity,
                                state: {
                                    id: row.visitorId,
                                    backUrl:{
                                        pathname: routes.visitor.list,
                                        state: {
                                            currentTab: TABS_VISITOR.REQUESTS.INDEX,
                                            currentSubView: VISITOR_SUB_VIEW_MODEL.REQUESTS.INVITATION_STATUS,
                                            invitationId:row.id,
                                            isOverdue: isOverdue
                                        }
                                }
                            }}}
                            icon={<NextIconsOptions/>}
                        />
                    )}
                    {(DEV || permission?.includes(permissionObj?.WEB_VISITOR_REQUEST_DELETE))
                    && invitationInTime(row.endDate) &&  (
                        <DropDownMenuItem
                            id={"btn_is_cancel" + row.id}
                            index={row.id}
                            handleClose={handleClose}
                            name={t('cancel')}
                            fontColor={"font-color-error-600"}
                            iconColor={"icon-color-error-code-600"}
                            click={() => {
                                setSelectedList([row?.id]); // Set selected item ID for deletion
                                setShowCancel(true);
                            }}
                            icon={<CancelIconsOptions/>}
                        />
                    )}
                </DropDownMenuProfile>
            </>
        )
    };

    const handleRowExpand = (row) => {
        if (row?.id !== expandedRowId) {
            setExpandedRowId(row?.id);
        }
    };

    const columns = [
        {
            field: 'hostName',
            label: 'requested_by',
            fixed: true,
            left: DEFAULT_LEFT,
            customWidth: WIDTH_COLUMN_FIXED,
            classNameContainerTooltip: WIDTH_TOOLTIP_FIXED_COLUMN,
            render: (value, row) => getFullName(
                row?.hostName,
                row?.hostLastName,
                row?.hostSecondLastName
            )
        },
        {
            field: 'visitorName',
            label: 'visitor',
            fixed: true,
            left: LEFT_SECOND_COLUMN_WITHOUT_CHECKBOX,
            customWidth: WIDTH_COLUMN_FIXED,
            classNameContainerTooltip: WIDTH_TOOLTIP_FIXED_COLUMN,
            render: (value, row) => getFullName(
                row?.visitorName,
                row?.visitorLastName,
                row?.visitorSecondLastName
            )
        },
        {
            field: 'visitorType.name', label: 'visitor_type',
            render: (value) => {
                return (
                    <CustomChip
                        className={"text-ellipsis"}
                        background={colors.secondary100}
                        fontColor={colors.secondary700}
                        borderColor={colors.secondary150}
                        legend={
                            <CustomTooltip text={value}>
                                {t(value) || EMPTY_VALUES.DEFAULT}
                            </CustomTooltip>
                        }
                    />


                );
            }
        },
        {
            field: 'visitorStatusId', label: 'visitor_status',
            render: (value) => {
                const text = status[value]
                return (
                    <CustomChip
                        className={"text-ellipsis"}
                        background={statusColor[value]}
                        fontColor={statusFontColor[value]}
                        borderColor={statusBorderColor[value]}
                        legend={
                            <CustomTooltip text={t(text)}>
                                {t(text) || EMPTY_VALUES.DEFAULT}
                            </CustomTooltip>
                        }
                        variant={'large'}
                    />
                );
            }
        }, {
            field: 'statusId', label: 'status',
            render: (value) => {
                const text = status[value]
                return (
                    <CustomChip
                        className={"text-ellipsis"}
                        background={statusColor[value]}
                        fontColor={statusFontColor[value]}
                        borderColor={statusBorderColor[value]}
                        legend={
                            <CustomTooltip text={t(text)}>
                                {t(text) || EMPTY_VALUES.DEFAULT}
                            </CustomTooltip>
                        }
                        variant={'large'}
                    />
                );
            }
        },
        {
            field: 'identityValidation', label: 'identityValidation',
            render: (value) => {
                 const text = status[value]
                return (
                    <CustomChip
                        className={"text-ellipsis"}
                        background={statusColor[value]}
                        fontColor={statusFontColor[value]}
                        borderColor={statusBorderColor[value]}
                        legend={
                            <CustomTooltip text={t(text)}>
                                {t(text) || EMPTY_VALUES.DEFAULT}
                            </CustomTooltip>
                        }
                        variant={'large'}
                    />
                );
            }
        },
        {
            field: 'identityValidationType', label: 'verification_method',
            render: (value) => {
                return (
                    <CustomChip
                        background={colors.secondary100}
                        fontColor={colors.secondary700}
                        borderColor={colors.secondary150}
                        legend={t(getIdentityValidationTypeById(value)?.trans) || EMPTY_VALUES.DEFAULT}
                    />
                );
            }
        },
    ];

    /**
     /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        const body = SEARCH_MODEL.setObject({page, size: rowsPerPage, model: option, viewType: INVITATION_VIEW_TYPE.INVITATION_STATUS, key:searchElement});
        setBodyForExport(body);
        dispatch(SimpleSearch({body})).then(
            ({payload: {data: {data, success}}}) => {
                if (success === true) {
                    setResults(data);
                }
            },
        );
    }

    const approvalStatusRulePayload = () => ({
        dataOption: SEARCH_OPERATION_MODEL.AND,
        fieldType: DATA_TYPE_MODEL.LONG,
        filterKey: fieldModelName.approvalStatus,
        operation: SEARCH_OPERATION_MODEL.EQ,
        sort: ORDER_MODEL.ASC,
        table: option,
        values: [STATUS_MODEL.APPROVED],
    });

    /**
     * Executes a paginated search request using advanced criteria.
     *
     * Builds the criteria list based on the advanced search (finalArray),
     * appends user criteria, and dispatches the search action through Redux.
     * Updates the results and resets the selected list once the data is returned.
     */
    const getDataAdvancedSearch = (page) => {
        const { dataOption: _a, ...approvalRule } = approvalStatusRulePayload();
        const finalTree = CRITERIA_MODEL.set(finalArray);
        const rootGroup = {
            dataOption: SEARCH_OPERATION_MODEL.AND,
            rules: [approvalRule],
            subGroups: finalTree ? [finalTree] : [],
        };
        const body = SEARCH_MODEL.setObject({ page, size: rowsPerPage, model: option, rootGroup });
        setCriteria(body);
        dispatch(SearchByFilters({ option, body })).then(({ payload: { data: { data } } }) => {
            setResults(data);
        });
    };


    // Use the TableFunction SubComponents to handle table logic (checkbox selection, pagination, etc.)
    const {
        t, handleCheckboxChange, handleDeleteAll, pagination, page, rowsPerPage,
        openMenu, handleMenuToggle, handleClose
    } = TableFunction({
        selectedList,
        setSelectedList,
        data: results,
        labelRowsPerPage: 'invitation_per_page',
        hasContainer: true,
        fixedPagination: false,
        searchElement,

        getData,//New
        modified,//New
        setModified,//New
        getDataAdvancedSearch,//New - apply only with advanced s
        finalArray,//New - apply only with advanced search
    });

    const cancelRequest = (ids) => {
        dispatch(CancelInvitation({ids: ids})).then(
            ({
                 payload: {
                     data: {success},
                 },
             }) => {
                if (success === true) {
                    setModified(true);
                    setSelectedList([]);
                    setIsAllChecked(false);
                    toast.success(t("has_been_cancelled_successfully"));
                }
            },
        );
    };

    return {
        columns,
        handleRowExpand,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        results,
        DEV,
        permission,
        setResults,
        option,
        page,
        rowsPerPage,
        userId: user.id,
        RenderOptionsMenu,
        searchId,
        setSimpleSearch,
        modified, setModified,

        showCancel,
        setShowCancel,
        cancelRequest,
        t
    }
}
